module.exports = __webpack_public_path__ + "img/bottle_borrow.5c06fddb.png";